import { api } from './api';

export const getFeatureFlags = () => api.get('/admin/feature-flags');
export const createFeatureFlag = (data: { key: string; enabled: boolean; description?: string }) =>
  api.post('/admin/feature-flags', data);
export const updateFeatureFlag = (id: string, data: { enabled?: boolean; description?: string }) =>
  api.patch(`/admin/feature-flags/${id}`, data);
